import { Switch, styled } from '@material-ui/core';

const SWITCH_COLORS = {
  green: {
    track: '#2A5333',
    checkedTrack: '#6CC551',
  },    
  blue: {
    track: '#708696',
    checkedTrack: '#145DAD',
  },
}

const I4kSwitch = styled(Switch)(() => {
  return {
  width: 64,
  height: 34,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    margin: 2,
    padding: 0,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(30px)',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: SWITCH_COLORS.green.checkedTrack,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#fff',
    width: 30,
    height: 30,
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 34 / 2,
    },
  };
});

export default I4kSwitch
